import { withInstall } from '@ll-plus/utils'

import CodemirrorEditorVue3 from './src/codemirror-editor-vue3.vue'

export const LlCodemirrorEditorVue3 = withInstall(CodemirrorEditorVue3)
export default LlCodemirrorEditorVue3
export * from './src/codemirror-editor-vue3'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlCodemirrorEditorVue3: typeof CodemirrorEditorVue3
  }
}
